export const filterConfig = [
  { key: "make", label: "Make", type: "single", optionsKey: "makes" },
  { key: "model", label: "Model", type: "single", optionsKey: "models" },
  { key: "modelCode", label: "Model Code", type: "single", optionsKey: "modelCodes" },

  { key: "price", label: "Price", type: "range", optionsKey: "prices" },
  { key: "year", label: "Year", type: "range", optionsKey: "years" },
  { key: "transmission", label: "Transmission", type: "single", optionsKey: "transmissions" },
  { key: "fuel", label: "Fuel", type: "single", optionsKey: "fuels" },
  { key: "vehicleType", label: "Vehicle Type", type: "single", optionsKey: "vehicleTypes" },
  { key: "engineCC", label: "Engine CC", type: "range", optionsKey: "engineCC" },

  { key: "wheelDrive", label: "Wheel Drive", type: "single", optionsKey: "wheelDrives" },
  { key: "steering", label: "Steering", type: "single", optionsKey: "steerings" },
  { key: "mileage", label: "Mileage", type: "range", optionsKey: "mileages" },
  { key: "country", label: "Country", type: "single", optionsKey: "countries" },
  { key: "interiorColor", label: "Interior Color", type: "single", optionsKey: "interiorColors" },
  { key: "exteriorColor", label: "Exterior Color", type: "single", optionsKey: "exteriorColors" },
  // { key: "doors", label: "No of Doors", type: "single", optionsKey: "doors" },
  // { key: "noOfSeats", label: "No of Seats", type: "single", optionsKey: "seats" },
  { key: "interiorCond", label: "Interior Conditions", type: "single", optionsKey: "interiorConditions" },
  { key: "exteriorCond", label: "Exterior Conditions", type: "single", optionsKey: "exteriorConditions" },
];